import React from 'react'
import { NavigateOptions, To, useNavigate } from 'react-router-dom'

function useLoggedNavigate() {
  const navigate = useNavigate()

  function loggedNavigate(delta: number): void
  function loggedNavigate(to: To | number, options?: NavigateOptions): void
  function loggedNavigate(
    toOrDelta: To | number,
    options?: NavigateOptions
  ): void {
    console.log(`Current location: ${window.location.href}`)
    console.log(`Navigating:\n${toOrDelta}\n${options}`)

    if (typeof toOrDelta === 'number') {
      navigate(toOrDelta)
    } else {
      navigate(toOrDelta, options)
    }
  }

  return loggedNavigate
}

export default useLoggedNavigate
